module.exports = __webpack_public_path__ + "img/c-service.1403b3c8.png";